import { HttpClient } from "@angular/common/http";
import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { DataTableDirective } from "angular-datatables";
import * as moment from "moment";
import { Subject } from "rxjs";
import { EncryptionService } from "src/app/_services/encryption.service";
import { ExcelService } from "src/app/_services/excel.service";
import { MentorshipDashboardService } from "src/app/_services/mentorship-dashboard.service";

declare const $: any;

class DataTablesResponse {
  data: any[];
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
}

@Component({
  selector: "app-logins-by-mentors",
  templateUrl: "./logins-by-mentors.component.html",
})
export class LoginsByMentorsComponent implements OnInit {
  @ViewChild("datePicker", { static: false }) datePicker: ElementRef;
  startDate: any = "";
  endDate: any = "";
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  // dtOptions: DataTables.Settings = {};
  dtOptions: DataTables.Settings = {
    pagingType: "full_numbers",
    pageLength: 10,
    columnDefs: [{ targets: [6], orderable: false }],
  };

  exportLoginMentorsList: any = [];
  fieldsToIncludeExcel: any = [];
  exl: boolean = false;
  dtTrigger = new Subject();
  loginMentorsList: any = []; // Table Data list
  dateInvalid: boolean = false;
  today: string = "";

  constructor(
    public router: Router,
    private http: HttpClient,
    private dataService: MentorshipDashboardService,
    private enc_dec: EncryptionService,
    private excelService: ExcelService
  ) {
    const now = new Date();
    this.today = now.toISOString().split("T")[0];
  }

  totalLoginMentors: any;
  modalReference: NgbActiveModal;
  modalCropper: NgbActiveModal;

  showloding = true;
  lodingImage = false;
  isSubmitted = false;
  ngOnInit() {
    window.scroll(0, 0);

    const strtDate = sessionStorage.getItem("startDate");
    const endDate = sessionStorage.getItem("endDate");
    this.startDate = strtDate ? strtDate : "";
    this.endDate = endDate ? endDate : "";

    this.mentorLoginsListing();
    this.getListing();
  }

  getListing() {
    this.dtOptions = {
      pagingType: "full_numbers",
      pageLength: 10,
      serverSide: true,
      processing: true,
      ajax: (dataTablesParameters: any, callback) => {
        const data = {
          type: "mentor_logins",
          export: false,
          start_date: this.startDate,
          end_date: this.endDate,
        };

        const requestPayload = {
          ...dataTablesParameters,
          ...data,
        };

        const encryptedData = this.enc_dec.encrypt(
          JSON.stringify(requestPayload)
        );

        this.http
          .post<DataTablesResponse>(
            "/api/metric-list",
            { req_data: encryptedData },
            {}
          )
          .subscribe((response: any) => {
            const output = this.enc_dec.decrypt(response.res_data);
            const resp = JSON.parse(output);

            this.loginMentorsList = resp["data"];
            this.totalLoginMentors = resp["recordsFiltered"];

            callback({
              recordsTotal: resp["recordsTotal"],
              recordsFiltered: resp["recordsFiltered"],
              data: [],
            });
          });
      },
      columns: [{ data: "id" }, { data: "name" }, { data: "last_login" }],
    };
  }

  onReset() {
    this.isSubmitted = false;
    this.startDate = "";
    this.endDate = "";
    const table = $("#login_mentors").DataTable();
    table.ajax.reload(null, false);
    this.mentorLoginsListing();
  }

  onSearch() {
    this.isSubmitted = true;
    this.dateInvalid = false;

    if (!this.startDate || !this.endDate) {
      return;
    }

    const start = new Date(this.startDate);
    const end = new Date(this.endDate);

    if (start > end) {
      this.dateInvalid = true;
      return;
    }
    const table = $("#login_mentors").DataTable();
    table.ajax.reload(null, false);
    this.mentorLoginsListing();
  }

  loadShow() {
    this.showloding = true;
    this.lodingImage = false;
  }

  loadHide() {
    this.showloding = false;
    this.lodingImage = true;
  }

  mentorLoginsListing() {
    const data = {
      draw: 1,
      start: 0,
      length: 1,
      order: [
        {
          column: 0,
          dir: "asc",
        },
      ],
      search: {
        value: "",
        regex: false,
      },
      start_date: this.startDate,
      end_date: this.endDate,
      export: true,
      type: "mentor_logins",
    };

    this.loadShow();
    this.dataService
      .dataExport(data)
      .pipe()
      .subscribe((res) => {
        this.exportLoginMentorsList = res["data"];
        this.fieldsToIncludeExcel = ["name", "last_login"];
        this.exl = true;

        this.loadHide();
      });
  }

  exportToExcel() {
    this.excelService.generateExcel(
      this.exportLoginMentorsList,
      this.fieldsToIncludeExcel,
      "Mentor Logins"
    );
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next();
    $("#login_mentors").on("page.dt", function () {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    });
  }

  ngOnDestroy(): void {
    $("#login_mentors").off("page.dt");
    this.dtTrigger.unsubscribe();
  }

  blockTyping(event: KeyboardEvent) {
    event.preventDefault();
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    });
  }
}
